import React from "react";

import { SelectField } from "../../../../../../../../components/forms/fields";

const options = [
    {
        value: "Search result",
        label: "Search result"
    },
    {
        value: "Single result",
        label: "Single result"
    },
    {
        value: "Owner page",
        label: "Owner page"
    },
    {
        value: "No results",
        label: "No results"
    },
    {
        value: "other",
        label: "Other"
    }
];

const TemplateNameField = ({ className, name = "name", label = "Name", ...restProps }) => (
    <SelectField
        className={className}
        name={name}
        options={options}
        label={label}
        isMenuPortal
        {...restProps}
    />
);

export default TemplateNameField;
